// PDFGallery.jsx
import React, { useContext } from 'react';
import styled from 'styled-components';
import { Context } from './Context';
import { useNavigate } from 'react-router-dom';

// // Import your PDF files
// import PDF1 from '../PROJECTS/SCAN TO BIM SAMPLE PROJECT.pdf';
// import PDF2 from '../PROJECTS/5HECTARE PLANT DEVELOPMENT_CIVIL_STRUCTURAL DRAWINGS.pdf';
// import PDF3 from '../PROJECTS/AHU PLATFORM.pdf';
// import PDF4 from '../PROJECTS/CONCRETE WORK EXTENSION_WAREHOUSE.pdf';
// import PDF5 from '../PROJECTS/Infrastructural Development Project_Melegun Town.pdf';
// import PDF6 from '../PROJECTS/RESIDENTIAL DEVELOPMENT.pdf';

// Styled components
const GalleryContainer = styled.div`
  background-color: #f4f4f4;
  min-height: 100vh;
  padding: 50px 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 100px;
`;

const Title = styled.h1`
  color: #1a73e8;
  margin-bottom: 40px;
  font-family: 'Arial', sans-serif;
`;

const FileGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 25px;
  width: 100%;
  max-width: 1000px;
`;

const FileCard = styled.a`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-decoration: none;
  background: #ffffff;
  border-radius: 10px;
  padding: 20px;
  min-height: 120px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  transition: transform 0.2s, box-shadow 0.2s;
  font-family: 'Arial', sans-serif;
  font-weight: bold;
  color: #1a73e8;
  text-align: center;
  cursor:pointer;

  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.2);
  }
`;

const PDFTitle = styled.p`
  margin: 0;
  padding-top: 10px;
  font-size: 0.9rem;
`;

// const pdfFiles = [
//   { pdf: PDF1, title: 'SCAN TO BIM SAMPLE PROJECT' },
//   { pdf: PDF2, title: '5 HECTARE PLANT DEVELOPMENT' },
//   { pdf: PDF3, title: 'AHU PLATFORM' },
//   { pdf: PDF4, title: 'CONCRETE WORK EXTENSION' },
//   { pdf: PDF5, title: 'INFRASTRUCTURAL DEVELOPMENT PROJECT' },
//   { pdf: PDF6, title: 'RESIDENTIAL DEVELOPMENT' },
// ];

const PastProjects = () => {

const {selectedPdf, setSelectedPdf, pastProjects}=useContext(Context);
const navigate = useNavigate();


  return (
    <GalleryContainer>
      <Title>MY PAST PROJECTS</Title>
      <p
        style={{
          color: 'blue',
          fontFamily: 'Arial',
          marginBottom: '20px',
          fontStyle: 'italic',
        }}
      >
        (Click each project to explore)
      </p>

      <FileGrid>
    {pastProjects.slice(0, pastProjects.length - 3).map((p) => (
  <FileCard
    key={p.id}
    onClick={(e) => {
      e.preventDefault();
      window.open(p.file, "_blank", "noopener,noreferrer");
    }}
  >
    <PDFTitle>{p.title}</PDFTitle>
  </FileCard>
))}


      </FileGrid>
    </GalleryContainer>
  );
};

export default PastProjects;